<template>
  <div class="column">
    <columnTitle :data="title">
      <template #moreSlot>
        <slot name="moreSlot"></slot>
      </template>
    </columnTitle>
    <div :is="`item-${name}`" :data="content" class="column-box"></div>
  </div>
</template>

<script>
import columnTitle from './title.vue';
import itemPie from './itemPie.vue';
import itemTag from './itemTag.vue';
import itemTags from './itemTags.vue';
import itemToday from './itemToday.vue';
import itemWork from './itemWork.vue';
import itemFood from './itemFood.vue';
import itemTable from './itemTable.vue';
import itemRevenue from './itemRevenue.vue';
export default {
  name: 'ColItem',
  components: {
    itemPie,
    itemTag,
    itemTags,
    itemToday,
    itemWork,
    itemTable,
    itemRevenue,
    itemFood,
    columnTitle
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    title: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: [Object, Array],
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.column {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 30px 30px 0;
  margin-bottom: 16px;
  background: #fff;
  &-box {
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
